export const S3_BUCKET_BASE_URL = 'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/';

export const getImage = name => S3_BUCKET_BASE_URL + name;